<template>
  <div class="screen-sign">
    <div class="sign-wraper" :class="{'filter-blur':activitymoadal==true||signModal == true}">
      <div class="sign-code" v-show="signType==1">
        <div class="code-title">
          <span class="sign-text">{{ $t("sign.scanSign") }}</span>
          <span class="large" @click="showSignModal">
            <span class="iconfont icon-quanping-"></span>
            <span>{{ $t("sign.enlarge") }}</span>
          </span>
        </div>
        <div class="code-erweima">
          <canvas id="canvas"></canvas>
        </div>
      </div>
      <div class="sign-num">
        <div class="num-title">{{ $t("sign.signNum") }}</div>
        <div class="already-sign">
          <div class="text">{{ $t("sign.alreadySign") }}</div>
          <div class="num">
            <div class="animate" :class="{anim:animate==true}" ref="rollul">
              <span class="name" style="font-size:100px;">{{oldAbsenceNum}}</span>
              <span class="name" style="font-size:100px;">{{absenceNum}}</span>
            </div>
          </div>
          <div class="detail" @click="goSignDetail(1)">{{ $t("sign.viewDetail") }}&gt;&gt;</div>
        </div>
        <div class="no-sign">
          <div class="text">{{ $t("sign.notSign") }}</div>
          <div class="num">
            <div class="animate" :class="{anim1:animate1==true}" ref="rollul1">
              <span class="name" style="font-size:100px;">{{oldNotAbsenceNum}}</span>
              <span class="name" style="font-size:100px;">{{notAbsenceNum}}</span>
            </div>
          </div>
          <div class="detail" @click="goSignDetail(2)">{{ $t("sign.viewDetail") }}&gt;&gt;</div>
        </div>
      </div>
    </div>
    <div class="sign-modal" v-show="signModal" @click="closeSignModal">
      <div class="wraper">
        <div class="modal-title">
          <span>{{ $t("system.scanCode") }}</span>
        </div>
        <div class="erweima">
          <canvas id="canvas-large"></canvas>
          <div class="text">{{ $t("sign.supportAPP") }}</div>
        </div>
      </div>
      <div class="close" @click="closeSignModal">
        <span class="iconfont icon-guanbi"></span>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";
import EventHandler from "../../common/js/EventHandler";
export default {
  props: {
    activitymoadal: Boolean
  },
  name: "signIn",
  data() {
    return {
      animate: true,
      absenceNum: 0,
      oldAbsenceNum: 0,
      notAbsenceNum: 0,
      oldNotAbsenceNum: 0,
      signModal: false,
      timer: null,
      attendanceID: 0,
      userId: 0,
      timer1: null,
      animate: true,
      animate1: true,
      signType: "0",
      refreshCode: 0 //是否刷新二维码
    };
  },
  methods: {
    goSignDetail: function(type) {
      this.$router.replace({
        path: "/screenIndex/signDetail",
        query: { type: type }
      });
    },
    showSignModal: function() {
      this.signModal = true;
    },
    closeSignModal: function() {
      this.signModal = false;
    },
    getSignDetialApi: function() {
      var that = this;
      that.$http
        .get(
          that.baseURL1 +
            "/newAttendance/getNewAttendanceDetail/" +
            that.attendanceID +
            "/" +
            1 +
            "/" +
            1
        )
        .then(res => {
          var data = res.data;
          that.signType = data.type;
          that.refreshCode = data.refreshCode;
          //将title等传给父路由
          if (!data.title) {
            data.title = that.common.getLocalTime(data.createDate) + this.$t('screen.actSign');
          }
          that.$emit("pushDetial", data);
          if (data.absenceNum != that.absenceNum) {
            that.absenceNum = data.absenceNum;
            that.scroll();
          }
          if (data.notAbsenceNum != that.notAbsenceNum) {
            that.notAbsenceNum = data.notAbsenceNum;
            that.scroll1();
          }
          if (data.finish == 0) {
            this.$router.replace({ path: "/screenIndex/signDetail?type=2" });
          }
        });
    },
    getSignDetial: function() {
      var that = this;
      this.timer = setInterval(function() {
        that.getSignDetialApi();
      }, 2000);
    },
    useqrcode() {
      //生成的二维码内容，可以添加变量
      var that = this;
      var attendanceID = that.attendanceID;
      var ocId = that.ocId;
      that.$http
        .get(that.baseURL1 + "/newAttendance/getAttendanceCode/" + attendanceID)
        .then(res => {
          var code = res.data;
          that.QueryDetail =
            that.pathURL +
            "/r/?a=2&b=" +
            code +
            "&c=" +
            attendanceID +
            "&d=" +
            ocId;
          var canvas = document.getElementById("canvas");
          var canvasLarge = document.getElementById("canvas-large");
          QRCode.toCanvas(
            canvas,
            that.QueryDetail,
            { width: 512, height: 512 },
            function(error) {
              if (error) console.error(error);
              console.log("success!");
            }
          );
          QRCode.toCanvas(
            canvasLarge,
            that.QueryDetail,
            { width: 588, height: 588 },
            function(error) {
              if (error) console.error(error);
              console.log("success!");
            }
          );
        });
    },
    scroll() {
      let con = this.$refs.rollul;
      con.style.marginTop = "0px";
      this.animate = !this.animate;
      var that = this;
      setTimeout(function() {
        con.style.marginTop = "-84px";
        that.animate = !that.animate;
      }, 10);
    },
    scroll1() {
      let con1 = this.$refs.rollul1;
      con1.style.marginTop = "0px";
      this.animate1 = !this.animate1;
      var that = this;
      setTimeout(function() {
        con1.style.marginTop = "-84px";
        that.animate1 = !that.animate1;
      }, 10);
    },
    changeTab(param) {
      if (param == 1) {
        this.$router.replace({ path: "/screenIndex/signDetail?type=2" });
      } else {
        this.$router.replace({ path: "/screenIndex/signDetail?type=1" });
      }
    }
  },
  computed: {},
  mounted: function() {
    var that = this;
    that.useqrcode();
  },
  created: function() {
    EventHandler.bindEvent("changeTab", this.changeTab);
    this.userId = this.common.getCookie("userId");
    this.ocId = this.common.getCookie("ocId");
    this.attendanceID = this.common.getCookie("activityId");
    this.getSignDetialApi();
    this.getSignDetial();
  },
  watch: {
    absenceNum(newVal, oldVal) {
      console.log(newVal);
      console.log(oldVal);
    },
    refreshCode(newVal, oldVal) {
      var that = this;
      if (newVal == 1) {
        that.timer1 = setInterval(function() {
          that.useqrcode();
        }, 15000);
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
    clearInterval(this.timer1);
    this.timer1 = null;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "signIn.scss";
</style>



// WEBPACK FOOTER //
// src/components/signIn/signIn.vue